import { render, staticRenderFns } from "./AppOverviewNotificationCorrections.vue?vue&type=template&id=1205d49e&scoped=true&"
import script from "./AppOverviewNotificationCorrections.vue?vue&type=script&lang=ts&"
export * from "./AppOverviewNotificationCorrections.vue?vue&type=script&lang=ts&"
import style0 from "./AppOverviewNotificationCorrections.vue?vue&type=style&index=0&id=1205d49e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1205d49e",
  null
  
)

export default component.exports